import PrivacyPolicyBanner from './PrivacyPolicyBanner';
import PrivacyPolicySection from './PrivacyPolicySection';

function PrivacyPolicy() {
  return (
    <div>
      <PrivacyPolicyBanner />
      <PrivacyPolicySection />
    </div>
  );
}

export default PrivacyPolicy;